<template>
  <div id="main-wrapper">
      <NavbarDark/>
        <div class="error-container">    
          <div ref="animationContainer" class="lottie-animation"></div>
          <div class="error-content">
            <h1 class="text-4xl font-bold">404</h1>
            <p class="text-lg mt-2">{{$t('Oops! The page you are looking for does not exist.')}}</p>
            <router-link to="/" class="mt-4 inline-block bg-blue-500 px-4 py-2 rounded">
              {{ $t('Go Back Home') }}
            </router-link>
          </div>
        </div>
      <FooterTop :bg="'theme-bg'"/>

      <FooterDark/>

      <ScrollToTop/>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import lottie from "lottie-web";
import NavbarDark from "@/components/navbar/navbar-dark.vue"
import FooterDark from '@/components/footer/footer-dark.vue'
import FooterTop from '@/components/footer/footer-top.vue'
const animationContainer = ref(null);

onMounted(() => {
  lottie.loadAnimation({
    container: animationContainer.value,
    renderer: "svg",
    loop: true,
    autoplay: true,
    path: "https://lottie.host/d987597c-7676-4424-8817-7fca6dc1a33e/BVrFXsaeui.json",
  });
});
</script>

<style scoped>
.error-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f8f9fa;
}

.error-content {
  text-align: center;
}

.error-content h1 {
  font-size: 6rem;
  font-weight: bold;
  margin-bottom: 1rem;
}

.error-content p {
  font-size: 1.5rem;
  margin-bottom: 2rem;
}

.lottie-animation {
  max-width: 400px;
  margin-bottom: 2rem;
}
</style>
